import React, { HTMLAttributes, ReactElement } from 'react';
import { APP_POOL_CONFIG } from '@synergy/config';

import poolLogo from './pool-logo.svg';

export const PlaceholderIcon = (props: HTMLAttributes<HTMLImageElement>): ReactElement => {
    const { style, ...imgProps } = props;

    return (
        <img
            src={poolLogo}
            alt={`${APP_POOL_CONFIG['name_short']} logo`}
            {...imgProps}
            style={{ opacity: 0.2, padding: '16%', ...style }}
        />
    );
};
